import React, { useEffect, useState } from "react";
import { Loader2, FileText, Download } from "lucide-react";
import { toast } from "sonner";
import customerApi from "./customerApi";

const AUBERGINE  = "var(--hq-deep, #5A4565)";
const PLUM       = "var(--hq-accent, #6F4A7A)";
const PARCH_EDGE = "#EFE4CC";

async function openInvoice(orderId) {
  try {
    const r = await customerApi.get(`/customer/orders/${orderId}/invoice/html`, { responseType: "text" });
    const blob = new Blob([r.data], { type: "text/html" });
    window.open(URL.createObjectURL(blob), "_blank", "noopener");
  } catch (e) {
    toast.error(e?.response?.status === 404
      ? "No invoice on file for this order yet."
      : "Couldn't open the invoice just now , please try again.");
  }
}

export default function HQStatements() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    customerApi.get("/customer/orders").then((r) => {
      const all = [].concat(r.data?.console || [], r.data?.online || [], r.data?.manual || []);
      // statements = orders that have an invoice number / total > 0
      all.sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")));
      setOrders(all.filter((o) => Number(o.total || 0) > 0));
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="hq-statements" className="space-y-5" style={{ color: AUBERGINE }}>
      <header>
        <div className="text-[10px] tracking-[0.45em] uppercase font-semibold" style={{ color: PLUM }}>✦ Heritage Headquarters</div>
        <h1 className="text-4xl mt-1.5">Statements</h1>
        <p className="italic opacity-75 text-sm mt-1">Invoices and receipts, newest first.</p>
      </header>

      {loading ? (
        <div className="opacity-70"><Loader2 className="w-4 h-4 inline animate-spin mr-2" />Loading…</div>
      ) : orders.length === 0 ? (
        <div className="bg-white border border-dashed rounded p-10 text-center italic opacity-70" style={{ borderColor: PARCH_EDGE }}>
          <FileText className="w-8 h-8 mx-auto mb-3 opacity-50" />
          No statements yet , invoices appear here once orders are paid.
        </div>
      ) : (
        <ul className="space-y-2" data-testid="hq-statements-list">
          {orders.map((o) => (
            <li key={o.id || o.order_number} className="bg-white border rounded p-4 flex items-center justify-between gap-3" style={{ borderColor: PARCH_EDGE }}>
              <div className="min-w-0">
                <div className="text-sm font-semibold">
                  <FileText className="w-3 h-3 inline mr-1.5" style={{ color: PLUM }} />
                  {o.order_number ? `Invoice #${o.order_number}` : `Ref ${String(o.id || "").slice(0, 8)}`}
                </div>
                <div className="text-xs opacity-70 mt-0.5">{String(o.created_at || "").slice(0, 10)}</div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <div className="text-sm font-semibold">NZ${Number(o.total || 0).toFixed(2)}</div>
                <button
                  type="button"
                  onClick={() => openInvoice(o.id)}
                  data-testid={`hq-statement-${o.id || "row"}`}
                  className="inline-flex items-center gap-1 px-3 py-1.5 text-[10px] tracking-[0.2em] uppercase font-semibold border rounded"
                  style={{ borderColor: AUBERGINE, color: AUBERGINE }}
                >
                  <Download className="w-3 h-3" /> View
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
